<template>
  <div>
    <div class="top-hero2">
      <div class="container">
        <div class="w-full sm:max-w-5xl mx-auto my-12 text-center rounded-lg">
          <div v-if="step1" class="sm:py-4 sm:px-6 lg:px-8">
            <template v-if="type == 'Seller'">
              <div class="card">
                <div>
                  <img
                    class="w-full object-cover"
                    src="https://homesby360.s3.amazonaws.com/bg2.jpg"
                    alt="homesby360"
                  />
                </div>
                <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                  <div
                    class="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5"
                  >
                    <div class="flex">
                      <img
                        class="h-20 w-20 rounded-full ring-4 ring-white sm:h-32 sm:w-32 object-cover"
                        src="../assets/Nicola.png"
                        alt="RealtorImage"
                      />

                      <div class="text-left mt-12 sm:mt-8 ml-1">
                        <h1
                          class="text-lg sm:text-2xl font-bold text-gray-700 truncate"
                        >
                          Nicola Burger (Broker in Charge)
                          <!-- <button type="button" class="inline-flex items-center px-3 py-1.5 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-full text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                      <i class="fas fa-play-circle -ml-0.5 mr-2 h-4 w-4"></i>
                                      About Me
                                    </button>  -->
                        </h1>
                      </div>
                    </div>
                  </div>

                  <p
                    class="mt-2 font-weight-light mx-auto text-lg text-center text-gray-500"
                  >
                    <span class="uppercase text-2xl sm:text-4xl">
                      Selling your home? Let's get started!</span
                    >
                    <br />
                    Professional marketing package includes drone and 360 video
                    and photography, social media exposure, best rates with
                    vendors, and a stress free listing process!
                  </p>
                </div>
              </div>
            </template>

            <template v-if="type == 'Management'">
              <div class="card">
                <div>
                  <img
                    class="w-full object-cover"
                    src="https://homesby360.s3.amazonaws.com/bg2.jpg"
                    alt="homesby360"
                  />
                </div>
                <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                  <div
                    class="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5"
                  >
                    <div class="flex">
                      <img
                        class="h-20 w-20 rounded-full ring-4 ring-white sm:h-32 sm:w-32 object-cover"
                        src="../assets/Nicola.png"
                        alt="RealtorImage"
                      />

                      <div class="text-left mt-12 sm:mt-8 ml-1">
                        <h1
                          class="text-lg sm:text-2xl font-bold text-gray-700 truncate"
                        >
                          Nicola Burger (Broker in Charge)
                          <!-- <button type="button" class="inline-flex items-center px-3 py-1.5 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-full text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                      <i class="fas fa-play-circle -ml-0.5 mr-2 h-4 w-4"></i>
                                      Watch Intro
                                    </button> -->
                        </h1>
                      </div>
                    </div>
                  </div>

                  <p
                    class="mt-2 font-weight-light mx-auto text-base text-center text-gray-500"
                  >
                    <span class="uppercase text-2xl sm:text-4xl"
                      >Why is 360 Real Estate the best choice for Property
                      Management?</span
                    >
                    <br />
                    Over a decade of experience with long term customers has
                    given us the real world know how of managing your property
                    and protecting your financial investment. <br />
                    Competitive Management Fees, Tri-Annual Inspections, Tax
                    documents provided and much more!
                  </p>
                </div>
              </div>
            </template>

            <template v-if="type == 'Buyer'">
              <div class="card">
                <div>
                  <img
                    class="w-full object-cover"
                    src="https://homesby360.s3.amazonaws.com/bg2.jpg"
                    alt="homesby360"
                  />
                </div>
                <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                  <div
                    class="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5"
                  >
                    <div class="flex">
                      <img
                        class="h-20 w-20 rounded-full ring-4 ring-white sm:h-32 sm:w-32 object-cover"
                        src="../assets/Nicola.png"
                        alt="RealtorImage"
                      />

                      <div class="text-left mt-12 sm:mt-8 ml-1">
                        <h1
                          class="text-lg sm:text-2xl font-bold text-gray-700 truncate"
                        >
                          Nicola Burger (Broker in Charge) <br />
                          <!-- <button type="button" class="inline-flex items-center px-3 py-1.5 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-full text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                      <i class="fas fa-play-circle -ml-0.5 mr-2 h-4 w-4"></i>
                                      Watch Intro
                                    </button> -->
                        </h1>
                      </div>
                    </div>
                  </div>

                  <p
                    class="mt-2 font-weight-light mx-auto text-lg text-center text-gray-500"
                  >
                    <span class="uppercase text-2xl sm:text-4xl">
                      Let's find your dream home together
                    </span>
                    <br />
                    Make the home buying experience fun and exciting <br />Get
                    started by creating your FREE account!
                  </p>
                </div>
              </div>
            </template>

            <div
              class="text-gray-700 mt-2 bg-gray-50 py-4 sm:py-8 px-4 shadow sm:rounded-lg sm:px-10 text-left"
            >
              <div
                class="sm:mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
              >
                <div class="sm:col-span-6">
                  <div>
                    <label
                      for="first-name"
                      class="block text-lg sm:text-xl sm:font-bold"
                    >
                      Name
                    </label>
                    <div class="mt-1">
                      <v-text-field
                        v-model="form.name"
                        outlined
                        :rules="firstRules"
                        :counter="20"
                        prepend-inner-icon="mdi-account"
                      ></v-text-field>
                    </div>

                    <label
                      for="email"
                      class="block text-lg sm:text-xl sm:font-bold"
                    >
                      Email address
                    </label>
                    <div class="mt-1">
                      <v-text-field
                        v-model="form.email"
                        outlined
                        :rules="emailRules"
                        prepend-inner-icon="mdi-email"
                      ></v-text-field>
                    </div>

                    <label
                      for="email"
                      class="block text-lg sm:text-xl sm:font-bold"
                    >
                      Phone
                    </label>
                    <div class="mt-1">
                      <v-text-field
                        outlined
                        v-model="form.phone"
                        :rules="phoneRules"
                        :counter="12"
                        prepend-inner-icon="mdi-cellphone"
                      ></v-text-field>
                    </div>
                  </div>
                </div>

                <div class="float-right mt-2">
                  <div class="text-sm">
                    <button
                      @click="createContact"
                      :disabled="
                        form.name.length <= 3 ||
                          form.email.length <= 8 ||
                          form.phone.length <= 9
                      "
                      type="button"
                      class="disabled:opacity-50 uppercase px-4 py-2 border-solid border-2 border-indigo-900 text-base font-medium rounded-md shadow-xl text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none"
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="step3"
            class="max-w-7xl mx-auto py-4 px-4 sm:py-4 sm:px-6 lg:px-8"
          >
            <div class="text-center">
              <!-- <h2
                style="-webkit-background-clip: text;"
                class="text-base font-semibold gradientCss tracking-wide uppercase"
              >
                Check our reviews
              </h2> -->
              <p
                class="text-3xl sm:text-4xl font-bold text-gray-100 sm:text-5xl sm:tracking-tight lg:text-6xl"
              >
                Verification code
              </p>
              <p class="max-w-xl mx-auto text-xl text-gray-400">
                Please complete signing up by checking the verification code
                sent to your phone!
              </p>
            </div>

            <div
              class="bg-white text-gray-800 py-8 px-4 shadow sm:rounded-lg sm:px-10"
            >
              <div class="sm:col-span-3 text-center">
                <label
                  style="-webkit-background-clip: text;"
                  for="first-name"
                  class="block text-xl font-light"
                >
                  Code
                </label>
                <div class="relative mt-1">
                  <div
                    class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                  >
                    <svg
                      class="h-5 w-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
                      />
                    </svg>
                  </div>

                  <input
                    type="integer"
                    v-model="form.code"
                    required
                    class="pl-10 block w-full px-3 py-2 border border-gray-300 rounded-md text-gray-800 font-medium focus:outline-none"
                  />
                </div>
              </div>

              <div
                class="text-right mt-3 grid grid-cols-1 sm:grid-cols-3 gap-2"
              >
                <button
                  :disabled="requestDisabled"
                  @click="register"
                  type="button"
                  class="disabled:opacity-50 disabled:bg-opacity-50 rounded-md shadow-sm px-4 py-2 text-base font-medium bg-blue-800 mr-2 text-white hover:bg-blue-800 focus:outline-none"
                >
                  Verify using email
                </button>

                <button
                  :disabled="requestDisabled"
                  @click="newCode()"
                  type="button"
                  class="disabled:opacity-50 disabled:bg-opacity-50 rounded-md shadow-sm px-4 py-2 text-base font-medium bg-blue-800 mr-2 text-white hover:bg-blue-800 focus:outline-none"
                >
                  Request a new code {{ timerCount }}
                </button>

                <button
                  @click="verifyCode"
                  :disabled="
                    disabledButton ||
                      form.code.length <= 3 ||
                      form.code.length >= 5
                  "
                  type="button"
                  class="disabled:opacity-50 uppercase px-4 py-2 border-solid border-2 border-indigo-900 text-base font-medium rounded-md shadow-xl text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none"
                >
                  Verify Code
                </button>
              </div>
            </div>
          </div>

          <div class="text-right my-4">
            <button
              @click="isSearch()"
              type="button"
              class="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-full shadow-sm text-white bg-gray-800 hover:bg-gray-900 focus:outline-none"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="block sm:hidden my-16"></div>
  </div>

  <!-- <seller-register :seller="seller"></seller-register> -->
</template>
<script>
// import anime from "animejs/lib/anime.es.js";
import Swal from "sweetalert2";
export default {
  props: ["type"],
  data() {
    return {
      requestNewCode: false,
      messageCode: "",
      form: {
        name: "",
        address: "",
        phone: "",
        email: "",
        password: "",
        password_confirmation: "",
        selected: this.type,
        verifiedCode: "",
        code: ""
      },

      errors: [],

      step1: true,
      step3: false,
      disabledButton: false,
      timerCount: 60,
      requestDisabled: true,

      url: "https://ui-avatars.com/api/?name=",
      rest: "&background=40c1ac&color=fff",

      firstRules: [
        v => !!v || "Fist name is required",
        v =>
          (v && v.length <= 20) || "Fist name must be less than 20 characters"
      ],

      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid",
        v => (v || "").indexOf(" ") < 0 || "No spaces are allowed"
      ],

      phoneRules: [
        v => !!v || "Phone is required",
        v => v.length <= 12 || "Phone must be less than 12 characters"
      ]
    };
  },

  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        } else if (value == 0) {
          this.requestDisabled = false;
        }
      },

      immediate: true // This ensures the watcher is triggered upon creation
    }
  },

  methods: {
    isSearch() {
      this.$router.push({
        name: "listings"
      });
    },

    showStep3() {
      this.step1 = false;
      this.step3 = true;
    },

    newCode() {
      //this.disabledButton = true;
      window.axios
        .post("/api/requestNewCode", {
          phone: this.form.phone,
          verifiedCode: this.form.verifiedCode
        })
        .then(res => {
          this.form.verifiedCode = res.data;
          this.timerCount = 30;
          this.requestDisabled = true;
        });
    },

    verifyCode() {
      //this.disabledButton = true;
      window.axios
        .post("/api/verifyCode", {
          requestedCode: this.form.code,
          verifiedCode: this.form.verifiedCode
        })
        .then(res => {
          this.disabledButton = false;

          if (res.data === "Done") {
            Swal.fire({
              icon: "success",
              title: "Verification code was successful"
            });
            this.register();
          } else {
            Swal.fire({
              icon: "error",
              title: "Verification failed with status",
              text: "The code provided does not match the expected value"
            });
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Verification failed",
            text: "The code provided does not match the expected value"
          });
        });
    },

    register() {
      window.axios.post("/api/storeUser", this.form).then(res => {
        this.form = {};

        if (res.data === "emailMessage") {
          //this.$router.push({ name: "VerifyMessage" });
          Swal.fire({
            icon: "success",
            title: "Verification code was successful"
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Account successfully created"
          });
          window.location.href = "https://www.homesby360.com/dashboard";
        }
      });
    },

    createContact() {
      window.axios.post("/api/saveContact", this.form).then(res => {
        if (res.data === "exists") {
          this.step1 = true;
          this.step3 = false;

          Swal.fire({
            icon: "error",
            title: "Duplicate Email",
            text:
              "This email is already register as a contact please try another"
          });
        } else {
          this.form.verifiedCode = res.data;
          this.step1 = false;
          this.step3 = true;
        }
      });
    }
  }
};
</script>
<style scoped>
.gradientCss {
  background: -webkit-linear-gradient(rgb(8, 181, 225), rgb(3, 107, 26));
  /* -webkit-background-clip: text; */
  -webkit-text-fill-color: transparent;
}
</style>
